import { Component, type ErrorInfo, type ReactNode } from 'react';

export interface SceneBoundaryProps {
  children: ReactNode;
  /** WebGL yo'q yoki sahna yiqilgan holatdagi ko'rinish. */
  fallback: ReactNode;
}

interface SceneBoundaryState {
  failed: boolean;
}

/**
 * 3D sahna uchun xato chegarasi.
 *
 * WebGL har joyda ishlamaydi: eski ish kompyuteri, o'chirilgan apparat
 * tezlatish, virtual mashina — bularning hammasi ombor ichida uchraydi.
 * Sahna yiqilsa **butun sahifa** oq ekranga aylanmasligi kerak: skladchi
 * chapdagi ro'yxat va skaner bilan ishini davom ettiradi.
 */
export class SceneBoundary extends Component<SceneBoundaryProps, SceneBoundaryState> {
  override state: SceneBoundaryState = { failed: false };

  static getDerivedStateFromError(): SceneBoundaryState {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    // Konsolga yoziladi: sabab (masalan "WebGL context yaratilmadi") aniq
    // ko'rinishi kerak, aks holda "3D ochilmadi" shikoyatini tekshirib
    // bo'lmaydi.
    console.error('[warehouse-3d] sahna yiqildi', error, info.componentStack);
  }

  override render(): ReactNode {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
